import React from 'react';
import { UploadCloud } from 'lucide-react';

const EmptyState = () => {
  return (
    <div className="flex flex-col items-center justify-center text-center p-6 space-y-4">
      <div className="p-4 bg-blue-50 rounded-full shadow-sm">
        <UploadCloud className="w-10 h-10 text-blue-500" />
      </div>
      <div>
        <h3 className="text-lg font-semibold text-gray-800">
          Drag & Drop Purchase Order Here
        </h3>
        <p className="text-sm text-gray-500 mt-1">or Browse Files</p>
      </div>
    </div>
  );
};

export default EmptyState;
